import { Component, OnInit } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
// import { TripsProvider } from '../../providers/trip/trip'
import { GlobalSearchPipe } from '../../pipes/global-search.pipe';
import { AwsService } from '../../providers/appsyncservice/aws.service';
import {InfoServiceService} from '../../service/rightinfo/info-service.service';
import { AppConstants } from '../../constants/app-constants';

@Component({
  selector: 'app-finishedscreen',
  templateUrl: './finishedscreen.component.html',
  styleUrls: ['./finishedscreen.component.css']
})
export class FinishedscreenComponent implements OnInit {

  users;
  finishedTrips: any;
  searchText: string;
  nextToken: String = "";
  constructor(public awserviceProvider: AwsService,  private infoService : InfoServiceService) {
    infoService.setUrl(AppConstants.FINISHED_SCREEN);
    this.searchText = "";
    this.getFinishedTrips()
  }

  ngOnInit() {
    this.finishedTrips = [];
    this.searchText = "";

  }

  getFinishedTrips() {
    let dateFormat = require('dateformat');
    let now = new Date();
    now.setDate(now.getDate() + 1);
    let lecondition = dateFormat(now, "yyyy-mm-dd");
    let prevdate = new Date();
    prevdate.setDate(prevdate.getDate() -2);
    let gecondition = dateFormat(prevdate, "yyyy-mm-dd");
  

    var that = this
    this.awserviceProvider.getTripsByStatusNextToken(2,lecondition,gecondition,this.nextToken).then((res:any) => {

      if (res.nextToken != null) {
        this.nextToken = res.nextToken;
        console.log("this.nextToken", this.nextToken)
        this.getFinishedTrips();
      }

      let finishedlst: any=[];
      finishedlst = res.items;
      finishedlst.forEach(trip => {
        this.awserviceProvider.getUserTripByDriverId(trip.id, trip.driver_id).then(usertrip => {
          trip.loc = usertrip[0];
        })
        this.awserviceProvider.getRncUsers(trip.driver_id).then(driver => {
          trip.driver = driver;
          this.finishedTrips.push(trip);
          this.searchText = "";
        //  console.log(" this.finishedTrips", this.finishedTrips)
        })
      })
    });
   
  }

}
